<template>
    <div>
        <Header></Header>
        <div class="notification">
            <h2>{{ title }}</h2>
            <div class="content" v-html="content"></div>
        </div>
        <Foot></Foot>
    </div>
</template>
<script>
import Header from "@/components/header";
import Foot from "@/components/foot";

export default {
    components: {
        Header,
        Foot
    },
    data() {
        return {
            title: "",
            content: ""
        }
    },
    created() {
        this.getContent();
    },
    methods: {
        //获取内容
        getContent() {
            if(this.$route.params && this.$route.params.content) {
                this.title = this.$route.params.title;
                this.content = this.$route.params.content;
            }
        },
    }
}
</script>
<style>
.notification {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 650px;
    font-size: 14px;
    padding: 15px;
    background-color: #fff;
}
.notification h2 {
    font-size: 22px;
    font-weight: bold;
    padding: 20px 0;
}
.notification .content {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.notification img{
    max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/notification.vue